var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.365,
    height: 15.313,
    viewBox: "0 0 15.365 15.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#383636;stroke:#383636;stroke-width:0.2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.891,16.221a.755.755,0,0,0-1.068,0l-6.266,6.267L17.29,16.221a.756.756,0,0,0-1.068,1.068l6.266,6.267-6.266,6.267a.756.756,0,1,0,1.068,1.068l6.266-6.267,6.266,6.267a.756.756,0,1,0,1.068-1.068l-6.266-6.267,6.266-6.267A.755.755,0,0,0,30.891,16.221Z",
    transform: "translate(-15.848 -15.9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedClose);
export default __webpack_public_path__ + "static/media/selected-close.3cbe5bca32de9aa65a32339ec42b65cb.svg";
export { ForwardRef as ReactComponent };